export const name = 'viewerManagerDataApi' as const
